import React, { useRef } from 'react';
import { FIRESTORE_DB } from '../../firebase/FirebaseConfig';
import SelectButton from '../../components/SelectButton';
import TextInput from '../../components/TextInput';
import BubbleSelector from '../../components/BubbleSelector';
import { collection, addDoc } from 'firebase/firestore';
import styles from './SignUp.module.css';
import { schoolNames } from '../../assets/schools';
import CheckboxSelector from '../../components/CheckboxSelector';

function SignUp() {
    const firstName = useRef('');
    const lastName = useRef('');
    const phoneNumber = useRef('');
    const email = useRef('');
    const institution = useRef('');
    const role = useRef('');
    const roleOther = useRef('');
    const howHeard = useRef('');
    const howHeardOther = useRef('');

    // volunteer
    const availability = useRef({});
    const shifts = useRef({});
    const location = useRef({});

    // explorer
    const major = useRef('');
    const attendance = useRef('');
    const challenges = useRef('');
    const whichday = useRef('');
    const artorsci = useRef('');
    const hoodiesize = useRef('');
    const dietaryres = useRef('');
    const whyQuantum = useRef('');
    const whyArt = useRef('');
    const favoriteSong = useRef('');
    const favoriteMovie = useRef('');
    const favoriteMuseum = useRef('');
    // const artPrompt = useRef('');
    // const ethicsPrompt = useRef('');
    const bookPrompt = useRef('');
    const mergePrompt = useRef('');
    const artPrompt = useRef('');
    const q3Prompt = useRef('');

    // emergency contact information
    const emergencyContactFirstName = useRef('');
    const emergencyContactLastName = useRef('');
    const emergencyContactPhoneNumber = useRef('');
    const emergencyContactEmail = useRef('');
    const emergencyContactRelationship = useRef('');

    const canSubmit = useRef(true);

    const urlParams = new URLSearchParams(window.location.search);
    let userTypeParam = urlParams.get('userType');
    if (userTypeParam !== 'volunteer' && userTypeParam !== 'explorer') {
        userTypeParam = 'volunteer';
        urlParams.set('userType', userTypeParam);
        window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
    }
    const [userType, setUserType] = React.useState(urlParams.get('userType') || 'volunteer');

    const [showOtherRoleInput, setShowOtherRoleInput] = React.useState(false);
    const [showOtherHowHeardInput, setShowOtherHowHeardInput] = React.useState(false);
    const [submitted, setSubmitted] = React.useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!canSubmit.current)
            return;
        canSubmit.current = false;

        const data = {
            firstName: firstName.current.value,
            lastName: lastName.current.value,
            phoneNumber: phoneNumber.current.value.replace(/[^0-9]/g, ''),
            email: email.current.value,
            institution: institution.current.value,
            role: showOtherRoleInput ? roleOther.current.value : role.current.value,
            howHeard: showOtherHowHeardInput ? howHeardOther.current.value : howHeard.current.value,
            emergencyContactFirstName: emergencyContactFirstName.current.value,
            emergencyContactLastName: emergencyContactLastName.current.value,
            emergencyContactPhoneNumber: emergencyContactPhoneNumber.current.value.replace(/[^0-9]/g, ''),
            emergencyContactEmail: emergencyContactEmail.current.value,
            emergencyContactRelationship: emergencyContactRelationship.current.value,
            hoodiesize: hoodiesize.current.value,
            dietaryres: dietaryres.current.value,
        };

        if (userType === 'volunteer') {
            data.availability = availability.current.value;
            data.shifts = shifts.current.value;
            data.location = location.current.value;
        } else if (userType === 'explorer') {
            data.major = major.current.value;
            data.attendance = attendance.current.value;
            data.whichday = whichday.current.value;
            data.artorsci = artorsci.current.value;
            data.challenges = challenges.current.value;
            data.whyQuantum = whyQuantum.current.value;
            data.whyArt = whyArt.current.value;
            data.favoriteSong = favoriteSong.current.value;
            data.favoriteMovie = favoriteMovie.current.value;
            data.favoriteMuseum = favoriteMuseum.current.value;
            data.bookPrompt = bookPrompt.current.value;
            data.mergePrompt = mergePrompt.current.value;
            data.artPrompt = artPrompt.current.value;
            data.q3Prompt = q3Prompt.current.value;
        }

        // Add a new document with a generated ID
        const docRef = await addDoc(collection(FIRESTORE_DB, 'signups'), data);
        console.log('Document written with ID: ', docRef.id);

        setSubmitted(true);

        canSubmit.current = true;
    }

    if (submitted) {
        return (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <h1>Sign Up</h1>
                <p>Thank you for signing up!</p>
                <p>We will get back to you soon.</p>
            </div>
        );
    }

    const handleUserTypeChange = (option) => {
        setUserType(option);
    }

    return (
        <div>
            <h1>Sign Up</h1>
            <form onSubmit={handleSubmit} className={styles.form}>
                <BubbleSelector options={['volunteer', 'explorer']} onSelect={handleUserTypeChange} selectedOption={userType} />

                <br />

                <div className={styles.formRow}>
                    <TextInput label="First Name" ref={firstName} placeholder="John" />
                    <TextInput label="Last Name" ref={lastName} placeholder="Doe" />
                </div>

                <TextInput label="Phone Number" ref={phoneNumber} type="tel" pattern="\(?[0-9]{3}\)?-?[0-9]{3}-?[0-9]{4}" placeholder="(123) 456-7890" />

                <TextInput label="Email" ref={email} type="email" placeholder="john.doe@umd.edu" />

                <SelectButton label="Institution" ref={institution} options={[
                    { label: 'Select Institution', value: '' },
                    ...schoolNames.map((school) => ({ label: school, value: school })),

                 <div>
                        <p style={{ fontSize: 'small' }}>
                                Please choose 'Other' if you are not a university student.
                            </p>
                        </div>
                ]} />

                <SelectButton label="Role" ref={role} options={[
                    { label: 'Select Role', value: '' },
                    { label: 'High School Student', value: 'hsStudent' },
                    { label: 'Undergraduate Student', value: 'undergraduateStudent' },
                    { label: 'Graduate Student', value: 'graduateStudent' },
                    { label: 'Professional', value: 'professional' },
                    { label: 'Professor', value: 'professor' },
                    { label: 'Other', value: 'other' },
                ]} onChange={() => { setShowOtherRoleInput(role.current.value === 'other'); }} />

                {showOtherRoleInput && <TextInput label="Please specify your role..." ref={roleOther} showLabel={false} placeholder="e.g. Artist, Researcher, etc." />}

                {userType === 'explorer' &&
                    <TextInput label="Major" ref={major} placeholder="e.g. Computer Science, Physics, etc." />}

                <hr style={{ margin: '20px 0' }} />

                <SelectButton label="How did you hear about us?" ref={howHeard} labelType="prompt" options={[
                    { label: 'Select Option', value: '' },
                    { label: 'Social Media', value: 'socialMedia' },
                    { label: 'Friend/Colleague', value: 'friend' },
                    { label: 'Email Newsletter', value: 'emailNewsletter' },
                    { label: 'Website', value: 'website' },
                    { label: 'Other', value: 'other' },
                ]} onChange={() => { setShowOtherHowHeardInput(howHeard.current.value === 'other'); }} />
                {showOtherHowHeardInput && <TextInput label="Please specify how you heard about us..." showLabel={false} ref={howHeardOther} labelType="title" />}

                <hr style={{ margin: '20px 0' }} />

                {userType === 'volunteer' && (
                    <>
                        <CheckboxSelector label="What is your availability for the event?" ref={availability} options={[
                            { label: 'Friday', value: 'friday' },
                            { label: 'Saturday', value: 'saturday' },
        
                        ]} />

                        <CheckboxSelector label="I am available for the following shifts..." ref={shifts} options={[
                            { label: '11:00 AM– 1:00 PM (Friday)', value: '11-3-fri' },
                            { label: '1:00 PM– 3:00 PM (Friday)', value: '13-15-fri' },
                            { label: '3:00 PM– 6:00 PM (Friday)', value: '15-18-fri' },
                            { label: '6:00 PM– 9:00 PM (Friday)', value: '18-21-fri' },
                            { label: '8:00 AM–10:00 AM (Saturday)', value: '8-10-sat' },
                            { label: '10:00 AM–12:00 PM (Saturday)', value: '10-12-sat' },
                            { label: '12:00 PM–3:00 PM (Saturday)', value: '12-15-sat' },
                            { label: '3:00 PM–6:00 PM (Saturday)', value: '15-18-sat' },
                            { label: '6:00 PM–9:00 PM (Saturday)', value: '18-21-sat' },
                        ]} />
                        <CheckboxSelector label="Where would you like to volunteer?" ref={location} options={[
                            { label: 'Registration', value: 'registration' },
                            { label: 'Set Up', value: 'setup' },
                            { label: 'Virtual Moderator', value: 'virtualModerator' },
                            { label: 'Exhibitions', value: 'exhibitions' },
                            { label: 'Workshops', value: 'workshops' },
                            { label: 'Performances', value: 'performances' },
                        ]} />

                        <SelectButton ref={hoodiesize} options={[
                            { label: 'Select Option', value: '' },
                            { label: 'S - small', value: 'small' },
                            { label: 'M - Medium', value: 'medium' },
                            { label: 'L - Large', value: 'large' },
                            { label: 'XL - Extra Large', value: 'xlarge' },
                        ]} showLabel={true} label="What is your sweater size?" labelType="prompt" />

                         <TextInput label="Do you have any dietary restrictions?" ref={dietaryres} showLabel={true} labelType="prompt" placeholder="e.g. None" />
                        <h2 style={{ fontSize: 'medium', textAlign: 'center' }}>Emergency Contact Information</h2>
                        <div className={styles.formRow}>
                        <TextInput label="First Name" ref={emergencyContactFirstName} placeholder="Jane" />
                        <TextInput label="Last Name" ref={emergencyContactLastName} placeholder="Doe" />
                        </div>
                        <TextInput label="Phone Number" ref={emergencyContactPhoneNumber} type="tel" pattern="\(?[0-9]{3}\)?-?[0-9]{3}-?[0-9]{4}" placeholder="(123) 456-7890" />
                        <TextInput label="Email" ref={emergencyContactEmail} type="email" placeholder="jane.doe@umd.edu" />
                        <TextInput label="Relationship" ref={emergencyContactRelationship} placeholder="e.g. Parent, Guardian, etc." />
                    </>
                )}

                {userType === 'explorer' && (
                    <>
                        <SelectButton ref={attendance} options={[
                            { label: 'Select Option', value: '' },
                            { label: 'In-Person*', value: 'inPerson' },
                            { label: 'Virtually', value: 'virtual' },
                        ]} showLabel={true} label="Will you be attending in-person or virtually?" labelType="prompt" />

                        <div>
                            <p style={{ fontSize: 'small' }}>
                                *Due to capacity constraints, we are only accepting 300 in-person applicants. Choosing in-person attendance does not guarantee acceptance. We will notify you if you have been selected to attend in-person. First 100 participants will get exclusive merch!
                            </p>
                        </div>

                        <SelectButton ref={whichday} options={[
                            { label: 'Select Option', value: '' },
                            { label: 'Both', value: 'both' },
                            { label: 'Friday only', value: 'friday' },
                            { label: 'Saturday only', value: 'saturday' },
                            { label: 'Will not be attending', value: 'notattend' },
                        ]} showLabel={true} label="Which days will you be attending?" labelType="prompt" />

                        <div>
                            <p style={{ fontSize: 'small' }}>
                                Priority will be given to those attending both days.
                            </p>
                        </div>

                        <SelectButton ref={challenges} options={[
                            { label: 'Select Option', value: '' },
                            { label: 'Yes', value: 'yes' },
                            { label: 'No', value: 'no' },
                        ]} showLabel={true} label="Will you be attempting the challenges?" labelType="prompt" />

                        <div>
                            <p style={{ fontSize: 'small' }}>
                                Teams of up to 4 are allowed. Each team must have one artist. Challenges are open to all.
                            </p>
                        </div>

                        <SelectButton ref={hoodiesize} options={[
                            { label: 'Select Option', value: '' },
                            { label: 'S - small', value: 'small' },
                            { label: 'M - Medium', value: 'medium' },
                            { label: 'L - Large', value: 'large' },
                            { label: 'XL - Extra Large', value: 'xlarge' },
                        ]} showLabel={true} label="What is your sweater size?" labelType="prompt" />

                         <TextInput label="Do you have any dietary restrictions?" ref={dietaryres} showLabel={true} labelType="prompt" placeholder="e.g. None" />
                        
                        <SelectButton ref={artorsci} options={[
                            { label: 'Select Option', value: '' },
                            { label: 'Both', value: 'both' },
                            { label: 'I am more an art person.', value: 'art' },
                            { label: 'I am more a science person.', value: 'science' },
                        ]} showLabel={true} label="Do you consider yourself an art person or a science person?" labelType="prompt" />


                        <hr style={{ margin: '20px 0' }} />

                        <TextInput label="Why quantum?" ref={whyQuantum} showLabel={true} labelType="prompt" placeholder="I am interested in quantum because..." />
                        <TextInput label="Why art?" ref={whyArt} showLabel={true} labelType="prompt" placeholder="I am interested in art because..." />

                        <TextInput label="If you were to write a book, what would it be about?" ref={bookPrompt} showLabel={true} labelType="prompt" placeholder="My pet dog..." />
                        <TextInput label="Suppose you were to merge quantum and music. What would you create?" ref={mergePrompt} showLabel={true} labelType="prompt" placeholder="A quantum keyboard..." />
                        <TextInput label="What medium allows you to best express your creativity?" ref={artPrompt} showLabel={true} labelType="prompt" placeholder="Paint..." />
                        <TextInput label="What do you look forward to at Q^3?" ref={q3Prompt} showLabel={true} labelType="prompt" placeholder="Lots of fun..." />

                        <h2 style={{ fontSize: 'medium', textAlign: 'center' }}>Emergency Contact Information</h2>
                        <div className={styles.formRow}>
                        <TextInput label="First Name" ref={emergencyContactFirstName} placeholder="Jane" />
                        <TextInput label="Last Name" ref={emergencyContactLastName} placeholder="Doe" />
                        </div>
                        <TextInput label="Phone Number" ref={emergencyContactPhoneNumber} type="tel" pattern="\(?[0-9]{3}\)?-?[0-9]{3}-?[0-9]{4}" placeholder="(123) 456-7890" />
                        <TextInput label="Email" ref={emergencyContactEmail} type="email" placeholder="jane.doe@umd.edu" />
                        <TextInput label="Relationship" ref={emergencyContactRelationship} placeholder="e.g. Parent, Guardian, etc." />
                    </>
                )}

                <hr style={{ margin: '20px 0' }} />

                

                <br />

                <button type="submit" className={styles.submitButton}>Sign Up</button>

                <br />
            </form>
        </div>
    );
};

export default SignUp;
